import { PermissionsType } from "../../types/shared/auth/permissionsTypes";

export const userHasAllRequiredPermissions = (requiredPermissions: PermissionsType, currentUserPermissions: PermissionsType): boolean => {
    return (currentUserPermissions & requiredPermissions) === requiredPermissions;
}

export const userHasAnyRequiredPermissions = (requiredPermissions: PermissionsType, currentUserPermissions: PermissionsType): boolean => {
    return !!(currentUserPermissions & requiredPermissions);
}
